import { z } from "zod";
import { makeGetRequest } from "../../utils";

const RecordingFile = z.object({
	id: z.string(),
	recording_start: z.string(),
	recording_end: z.string(),
	file_type: z.string(),
	file_size: z.number(),
	download_url: z.string(),
	status: z.string(),
	deleted_time: z.optional(z.string()),
	recording_type: z.string(),
});

const ParticipantVideoFile = z.object({
	id: z.string(),
	recording_start: z.string(),
	recording_end: z.string(),
	file_name: z.string(),
	file_type: z.string(),
	file_extension: z.string(),
	file_size: z.number(),
	download_url: z.string(),
	recording_type: z.string(),
	status: z.string(),
	user_id: z.string(),
	user_key: z.string(),
});

const Session = z.object({
	session_id: z.string(),
	session_name: z.string(),
	start_time: z.string(),
	duration: z.number(),
	total_size: z.number(),
	recording_count: z.number(),
	recording_files: z.array(RecordingFile),
	participant_video_files: z.array(ParticipantVideoFile),
});

const ResponseSchema = z
	.object({
		from: z.string(),
		to: z.string(),
		page_size: z.number(),
		total_records: z.number(),
		next_page_token: z.string(),
		sessions: z.array(Session),
	})
	.deepPartial();

type Response = z.infer<typeof ResponseSchema>;
type ListRecordingsOfAnAccountOptions = {
	from: string;
	to: string;
	page_size?: number;
	next_page_token?: string;
	trash?: boolean;
	trash_type?: "session_recordings" | "recording_file";
};
export const listRecordingsOfAnAccount = async (
	token: string,
	options: ListRecordingsOfAnAccountOptions,
): Promise<Response> => {
	const res = await makeGetRequest({
		token,
		pathList: ["v2", "videosdk", "recordings"],
		options,
	});
	return ResponseSchema.parse(res);
};

export const curriedListRecordingsOfAnAccount = (token: string) => (
	options: ListRecordingsOfAnAccountOptions,
) => listRecordingsOfAnAccount(token, options);